import * as React from 'react';
import { useState } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { MenuItem, FormControl, FormHelperText, InputLabel } from '@mui/material';
import Select from '@mui/material/Select';
import { useData } from '../Form';
import { useStep } from '../Form';
import { useConferenceConfig } from '../components/ConferenceConfigContext';
import BackAndNextButtons from '../components/BackAndNextButtons';

const DEFAULT_SIZES = ['S', 'M', 'L', 'XL', 'XXL'];

export default function TShirtForm() {
  const { data, updateData } = useData()
  const { incrementStep } = useStep();
  const { config } = useConferenceConfig();

  const tshirtConfig = config.tshirt || {};
  const name = tshirtConfig.name || 'T-Shirt';
  const price = tshirtConfig.unit_amount?.value ?? 17;
  const currencyCode = tshirtConfig.unit_amount?.currency_code || 'USD';
  const sizes = tshirtConfig.sizes?.length ? tshirtConfig.sizes : DEFAULT_SIZES;
  const description = tshirtConfig.description || `T-shirts cost $${price}. If you would like one, please select a size below.`;

  const [values, setValues] = useState({
    shirtsize: data.shirtsize ?? 'none', // Ensure data exists with optional chaining
  });

  const products = data.products || []; // Assuming products are stored in `data`
  const hasTShirt = products.some((product) => product.name === name);

  function handleNext() {
    updateData(values); // Save the current form data
    if (values.shirtsize !== 'none') {
      // Add or update the t-shirt product in the products array
      if (!hasTShirt) {
        products.push({
          name,
          description: values.shirtsize,
          quantity: 1,
          unit_amount: { value: price, currency_code: currencyCode },
        });
      } else {
        // Update the existing t-shirt product
        const tShirtProduct = products.find((product) => product.name === name);
        tShirtProduct.description = values.shirtsize; // Update the size
      }
    } else {
      // Remove the t-shirt product if the size is set to 'none'
      if (hasTShirt) {
        const productIndex = products.findIndex((product) => product.name === name);
        products.splice(productIndex, 1); // Remove the t-shirt product
      }
    }

    // Update the product list in data
    updateData({ products: products, shirtsize: values.shirtsize });

    // Proceed to the next step
    incrementStep();
  }

  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        T-Shirts
      </Typography>

      <Grid container spacing={3}>
        {tshirtConfig.imageUrl && (
          <Grid item xs={12}>
            <img className="T-Shirt" src={tshirtConfig.imageUrl} alt={"College Conference"} style={{ objectFit: 'fill', width: '100%' }} />
          </Grid>
        )}

        <Grid item xs={12}>
          <Typography variant="body1" paragraph={true}>
            {description}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth size="small">
            <InputLabel id="shirt-label">T-Shirt Size</InputLabel>
            <Select
              labelid='shirt-label'
              id="shirt"
              value={values.shirtsize}
              label="T-Shirt Size"
              onChange={(e) => {
                setValues({ ...values, ...{ shirtsize: e.target.value } })
              }}
            >
              {sizes.map((size) => <MenuItem key={size} value={size}>{size}</MenuItem>)}
              <MenuItem value={'none'}>None</MenuItem>
            </Select>
            <FormHelperText>Gender Neutral Sizes</FormHelperText>
          </FormControl>
        </Grid>
      </Grid>
      <BackAndNextButtons handleNext={handleNext}></BackAndNextButtons>
    </React.Fragment>
  );
}
